import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import {HttpClient, HttpEvent} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import {Requests} from '../_model/Requests';
import {RequestsRequest} from '../_model/request/RequestsRequest';
import {WfCompleteRequest} from '../_model/request/WfCompleteRequest';

@Injectable({
  providedIn: 'root'
})
export class RequestService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  cancelRequest(requests: WfCompleteRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/requests/process/cancel', requests)
  }
  completeRequests(requests: WfCompleteRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/requests/process/complete', requests)
  }
  approveRequests(requests): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/wf/approvals', requests);
  }
  rejectRequests(requests): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/wf/approvals/reject', requests);
  }
  saveRequests(requestsRequest: RequestsRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/requests', requestsRequest);
  }

  updateRequests(requestsRequest: RequestsRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/requests', requestsRequest);
  }
  getById(id: number): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/requests/' + id);
  }

  listRequests(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/requests');
  }

  deleteRequests(requests: Requests): Observable<ApiResponse> {
    return this.delete<ApiResponse>('/api/v1/requests/' + requests.id);
  }

  uploadRequestsFile(formData: FormData, recordId: number): Observable<HttpEvent<ApiResponse>> {
    return this.upload<ApiResponse>('/api/v1/requests/uploadfile/' + recordId, formData);
  }

  listRequestsByEmployeeId(employeeId: number): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/requests/employee/' + employeeId);
  }

}